import { Image } from "primereact/image";

import { labelNoCodes } from "_constants";
import notFoundProject from "../../../../../assets/images/element_not_found.svg";

export const EmptyCodesList = () => {
  return (
    <div className="width-100 height-100 flex-container column align-center justify-center">
      <Image src={notFoundProject} alt={labelNoCodes} />
      <p className="empty-cards light-grey">{labelNoCodes}</p>
    </div>
  );
};
